import { jsx as _jsx } from "react/jsx-runtime";
import { ToggleGroup, ToggleGroupItem } from '@patternfly/react-core';
import { useCallback, useState, } from 'react';
import { isDefined } from '../utils';
export const SimpleSelector = ({ selectedItem, items, id, onChange, 'aria-label': ariaLabel, 'data-testid': dataTestId, }) => {
    const [selected, setIsSelected] = useState(selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.name);
    const onItemChanged = useCallback((event) => {
        var _a;
        const name = (_a = event.currentTarget) === null || _a === void 0 ? void 0 : _a.id;
        setIsSelected(name);
        if (!isDefined(name)) {
            onChange === null || onChange === void 0 ? void 0 : onChange(undefined);
            return;
        }
        const localItem = items.find((item) => item.name === name);
        if (name !== (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.name)) {
            onChange === null || onChange === void 0 ? void 0 : onChange(localItem);
        }
    }, [onChange, items, selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.name]);
    return (_jsx(ToggleGroup, { id: id, "data-testid": dataTestId, "aria-label": ariaLabel, children: items.map((item) => (_jsx(ToggleGroupItem, { text: item.name, buttonId: item.name, isSelected: selected === item.name, onChange: onItemChanged }, item.name))) }));
};
//# sourceMappingURL=SimpleSelector.js.map